<portal-sub-nav [force]="force" route="end-user-call-center">
  <portal-menu-context [heading]="'menu.callCenter' | portalTranslate"></portal-menu-context>

  <!-- Agents -->
  <portal-sub-nav-item
    [activeRoutes]="['end-user-call-center-agents', 'end-user-call-center-agent']"
    route="end-user-call-center-agents"
  >
    <span *portalTransclude>{{ 'menu.callCenter.endUser.agents' | portalTranslate }}</span>
  </portal-sub-nav-item>

  <!-- Phone Book -->
  <portal-sub-nav-item route="end-user-call-center-phone-book">
    <span *portalTransclude>{{ 'menu.callCenter.phoneBook' | portalTranslate }}</span>
  </portal-sub-nav-item>

  <!-- Reports -->
  <portal-sub-nav-item route="end-user-call-center-reports">
    <span *portalTransclude>{{ 'menu.callCenter.reporting' | portalTranslate }}</span>
  </portal-sub-nav-item>

  <!-- Live Monitoring -->
  @if (isCallCenterSupervisor$ | async) {
    <portal-sub-nav-item route="end-user-call-center-live-monitoring">
      <span *portalTransclude>{{ 'menu.callCenter.liveMonitoring' | portalTranslate }}</span>
    </portal-sub-nav-item>
  }
</portal-sub-nav>
